// TODO: Translations and show error code from backend
import axios from 'axios';
import Auth from '@groovepages/gd-lib/auth';
import { getEmbeddedUser, clearEmbeddedUser } from '@/services/portal-embed-session';
import { rememberGrooveSellReturn } from '@/services/return-path';
import storage from 'local-storage-fallback';
import store from '@/store';
import Vue from 'vue';
import { handleAccountAccessDenial } from '../../../shared/accountAccess';

// Request interceptor
axios.interceptors.request.use(request => {
  const embeddedUser = getEmbeddedUser();
  const { token } = embeddedUser || Auth.authenticatedUser();
  const finalRequest = request;

  if (token) {
    finalRequest.headers.common.Authorization = `Bearer ${token}`;
    if (embeddedUser) {
      finalRequest.headers.Authorization = `Bearer ${token}`;
      finalRequest.headers['x-auth-provider'] = embeddedUser.auth_keycloak ? 'keycloak' : 'auth0';
      finalRequest.headers.common['x-auth-provider'] = embeddedUser.auth_keycloak ? 'keycloak' : 'auth0';
    }
  }

  return finalRequest;
});

// Response interceptor
axios.interceptors.response.use(
  response => response,
  error => {
    if (handleAccountAccessDenial(error)) {
      return Promise.reject(error);
    }

    const status = error.response ? error.response.status : 0;


    if (status === 401) {
      if (window.location.href.indexOf('promo-tools') > -1) {
        if (window.self !== window.top) {
          clearEmbeddedUser();
          window.dispatchEvent(new Event('groove-portal-session-expired'));
          return Promise.reject(error);
        }
        // Logout user for promo tools
        Auth.logout();
        window.location.reload();
        return Promise.reject(error);
      }
      store.commit('logout');
      rememberGrooveSellReturn(localStorage, window.location.href);
      window.location.replace(`${window.config.grooveappsurl}/#/login`);
    }

    return Promise.reject(error);
  }
);
